// pages/PasswordReset.js - v3.0 Password Reset Page

import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';

const PasswordReset = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('كلمات المرور غير متطابقة');
      return;
    }

    if (password.length < 6) {
      setError('كلمة المرور يجب أن تكون 6 أحرف على الأقل');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/users/reset-password`,
        {
          resetToken: token,
          newPassword: password
        }
      );

      setSuccess(true);
      setTimeout(() => {
        navigate('/login', {
          state: { message: 'تم تغيير كلمة المرور بنجاح، يمكنك تسجيل الدخول الآن' }
        });
      }, 2000);

    } catch (err) {
      console.error('Password reset error:', err);
      setError(err.response?.data?.error || 'فشل إعادة تعيين كلمة المرور');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Card style={{ width: '100%', maxWidth: '500px' }} dir="rtl">
        <Card.Body className="p-5">
          <div className="text-center mb-4">
            <h2>إعادة تعيين كلمة المرور</h2>
            <p className="text-muted">قم بإدخال كلمة المرور الجديدة</p>
          </div>

          {error && (
            <Alert variant="danger" dismissible onClose={() => setError(null)}>
              {error}
            </Alert>
          )}

          {success ? (
            <Alert variant="success">
              ✅ تم تغيير كلمة المرور بنجاح! جاري تحويلك لصفحة تسجيل الدخول...
            </Alert>
          ) : (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>كلمة المرور الجديدة</Form.Label>
                <Form.Control
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="أدخل كلمة المرور الجديدة"
                  minLength={6}
                />
                <Form.Text className="text-muted">
                  يجب أن تكون 6 أحرف على الأقل
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>تأكيد كلمة المرور</Form.Label>
                <Form.Control
                  type="password"
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="أعد إدخال كلمة المرور"
                />
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                className="w-100"
                disabled={loading}
              >
                {loading ? 'جاري التغيير...' : 'تغيير كلمة المرور'}
              </Button>
            </Form>
          )}

          <div className="text-center mt-4">
            <Link to="/login" className="text-decoration-none">
              العودة لتسجيل الدخول
            </Link>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PasswordReset;
